export default "__VITE_ASSET__BfBPGanY__"